import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'x-no-data',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './x-no-data.component.html',
  styleUrl: './x-no-data.component.scss',
})
export class XNoDataComponent {
  message = input('No data found.');
}
